import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const MarkCustomerDoneMutation = graphql(`
  mutation MarkCustomerDone($input: MarkCustomerDoneInput!) {
    markCustomerDone(input: $input) {
      clientId
      markedDoneAt
    }
  }
`);

export function useMarkCustomerDone() {
  const [result, _markCustomerDone] = useMutation(MarkCustomerDoneMutation);
  const [error, setError] = useState<Error | null>(null);

  const markCustomerDone = useCallback(
    async (clientId: string, reason?: string) => {
      try {
        const response = await _markCustomerDone({ input: { clientId, reason } });

        if (response.error) {
          throw response.error;
        }

        if (!response.data || !response.data.markCustomerDone) {
          throw new Error("No data returned from markCustomerDone mutation");
        }

        setError(null);

        return {
          clientId: response.data.markCustomerDone.clientId,
          markedDoneAt: response.data.markCustomerDone.markedDoneAt,
        };
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [_markCustomerDone],
  );

  return { markCustomerDone, result, error };
}
